import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import FormField from 'grommet/components/FormField';
import RadioButton from 'grommet/components/RadioButton';
import Button from 'grommet/components/Button';
import Form from 'grommet/components/Form';
import Select from 'grommet/components/Select';
import Layer from 'grommet/components/Layer';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import Revert from 'grommet/components/icons/base/Revert';
import Label from 'grommet/components/Label';
//import {fetchLookupServersList} from '../Redux/actions/SAPactions';
import { fetchLookupServersList } from '../../State/actions/sessions';
import { said } from '../../AppConfig';

var ServerType = "new";
var defaultserver = false;
var defaultCpuspeed = false;
var defaultNoofcpu = false;

class SANStorage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            LookupSAP: false,
            AllServersRadiobutton: false,
            OnlyNewServersRadiobutton: true,
            OnlyOldServersRadiobutton: false,
            NotNewServersRadiobutton: false,
            onEPH3: false,
            onEPH4: false,
            onEPH5: true,
            SAPversionvalue: '',
            SAPversionOptions: [],
            OperatingSystemvalue: 'WINDOWS',
            OperatingSystemOptions: [],
            ServerTypevalue: 'ProLiant',
            ServerTypeOptions: ["ProLiant", "Integrity"],
            ServerOptions: [],
            Servervalue: "",
            CpuspeedCachevalue: "",
            CpuspeedCacheoptions: [],
            NoofCPUSvalue: "",
            NoofCPUSvalueoptions: [],

        };
        this.onLookupSAPClick = this.onLookupSAPClick.bind(this);
        this.LookupSAPClose = this.LookupSAPClose.bind(this);
        this.onAllServersRadiobuttonChange = this.onAllServersRadiobuttonChange.bind(this);
        this.onOnlyNewServersRadiobuttonChange = this.onOnlyNewServersRadiobuttonChange.bind(this);
        this.onOnlyOldServersRadiobuttonChange = this.onOnlyOldServersRadiobuttonChange.bind(this);
        this.onNotNewServersRadiobuttonChange = this.onNotNewServersRadiobuttonChange.bind(this);
        this.onEPH3RadiobuttonChange = this.onEPH3RadiobuttonChange.bind(this);
        this.onEPH4RadiobuttonChange = this.onEPH4RadiobuttonChange.bind(this);
        this.onEPH5RadiobuttonChange = this.onEPH5RadiobuttonChange.bind(this);
        this.onSAPversionChange = this.onSAPversionChange.bind(this);
        this.onOperatingSystemChange = this.onOperatingSystemChange.bind(this);
        this.onServerTypeChange = this.onServerTypeChange.bind(this);
        this.onServerChange = this.onServerChange.bind(this);
        this.onCpuspeedCacheChange = this.onCpuspeedCacheChange.bind(this);
        this.onNoofCPUSvalueChange = this.onNoofCPUSvalueChange.bind(this);


    }
    onNoofCPUSvalueChange(e) {

        defaultNoofcpu = true;
        this.setState({ NoofCPUSvalue: e.value })
    }
    onCpuspeedCacheChange(e) {
        defaultCpuspeed = true;
        defaultNoofcpu = false;
        this.setState({ CpuspeedCachevalue: e.value })
    }
    onServerChange(e) {
        defaultserver = true;
        defaultCpuspeed = false;
        defaultNoofcpu = false;
        this.setState({ Servervalue: e.value })
    }
    onLookupSAPClick() {
        this.setState({ LookupSAP: true })
    }
    LookupSAPClose() {
        this.setState({ LookupSAP: false })
    }
    onOperatingSystemChange(e) {
        defaultserver = false;
        defaultCpuspeed = false;
        defaultNoofcpu = false;

        if (e.value === "HP-UX") {

            this.state.ServerTypeOptions = ["Integrity", "PA-RISC"]
        }
        else {
            this.state.ServerTypeOptions = ["ProLiant", "Integrity"]
        }
        this.setState({ OperatingSystemvalue: e.value, ServerTypevalue: this.state.ServerTypeOptions[0] })
    }
    onServerTypeChange(e) {
        defaultserver = false;
        defaultNoofcpu = false;
        defaultCpuspeed = false;
        this.setState({ ServerTypevalue: e.value })
    }
    onAllServersRadiobuttonChange() {
        let flag;
        if (this.state.AllServersRadiobutton === false) {
            flag = true;
            ServerType = "new";
        }
        else {
            flag = false;
        }

        this.setState({ AllServersRadiobutton: flag, OnlyNewServersRadiobutton: false, OnlyOldServersRadiobutton: false, NotNewServersRadiobutton: false })
    }
    onOnlyNewServersRadiobuttonChange() {
        let flag;
        if (this.state.OnlyNewServersRadiobutton === false) {
            flag = true;
            ServerType = "new";
        }
        else {
            flag = false;
        }

        this.setState({ AllServersRadiobutton: false, OnlyNewServersRadiobutton: flag, OnlyOldServersRadiobutton: false, NotNewServersRadiobutton: false })
    }
    onOnlyOldServersRadiobuttonChange() {
        let flag;
        if (this.state.OnlyOldServersRadiobutton === false) {
            flag = true;
            ServerType = "old";
        }
        else {
            flag = false;
        }

        this.setState({ AllServersRadiobutton: false, OnlyNewServersRadiobutton: false, OnlyOldServersRadiobutton: flag, NotNewServersRadiobutton: false })
    }
    onNotNewServersRadiobuttonChange() {
        let flag;
        if (this.state.NotNewServersRadiobutton === false) {
            flag = true;
            ServerType = "not new";
        }
        else {
            flag = false;
        }

        this.setState({ AllServersRadiobutton: false, OnlyNewServersRadiobutton: false, OnlyOldServersRadiobutton: false, NotNewServersRadiobutton: flag })
    }
    onEPH3RadiobuttonChange() {
        let flag;
        if (this.state.onEPH3 === false) {
            flag = true;
            this.state.SAPversionOptions = ["4.6", "4.7", "5.0", "6.0"]
            this.state.SAPversionvalue = this.state.SAPversionOptions[3]
        }
        else {
            flag = false;
        }
        this.setState({ onEPH3: flag, onEPH4: false, onEPH5: false })
    }
    onEPH4RadiobuttonChange() {
        let flag;
        if (this.state.onEPH4 === false) {
            flag = true;
            this.state.SAPversionOptions = ["4.6", "4.7", "5.0", "6.0 EHP4"]
            this.state.SAPversionvalue = this.state.SAPversionOptions[3]
        }
        else {
            flag = false;
        }
        this.setState({ onEPH4: flag, onEPH5: false, onEPH3: false })
    }
    onEPH5RadiobuttonChange() {
        let flag;
        if (this.state.onEPH5 === false) {
            flag = true;
            this.state.SAPversionOptions = ["4.6", "4.7", "5.0", "6.0 EHP5"]
            this.state.SAPversionvalue = this.state.SAPversionOptions[3]
        }
        else {
            flag = false;
        }

        this.setState({ onEPH5: flag, onEPH4: false, onEPH3: false })
    }
    componentDidMount() {
        if (this.props.LookupServers === null) {
            this.props.OnFetchLookupServersList('LookUp');
        }
        if (this.state.ServerOptions.length > 0)
            this.state.Servervalue = this.state.ServerOptions[0];
        this.setState({});
    }
    onSAPversionChange(e) {

        this.setState({ SAPversionvalue: e.value })
    }
    componentWillMount() {
        if (this.state.onEPH5 === true) {
            this.state.SAPversionOptions = ["4.6", "4.7", "5.0", "6.0 EHP5"];
            this.state.SAPversionvalue = this.state.SAPversionOptions[3]
        }

        if (this.state.ServerOptions.length > 0)
            this.state.Servervalue = this.state.ServerOptions[0];

        if (said === 'SAPHANA') {
            this.state.OperatingSystemOptions = ["LINUX", "WINDOWS"]
            this.state.OperatingSystemvalue = 'LINUX'
        } else {
            this.state.OperatingSystemOptions = ["WINDOWS", "LINUX"]
        }
    }
    render() {
        var LookupValue;
        var LookupTotalValue;
        var DbNewSap;
        let Cac;
        //let serverduplicate = false;
        //Default Servers
        if (this.props.LookupServers !== null) {
            let OsType = '';
            this.state.ServerOptions = [];
            this.state.CpuspeedCacheoptions = [];
            this.state.NoofCPUSvalueoptions = [];
            OsType = this.state.OperatingSystemvalue + " " + this.state.ServerTypevalue;
            //  console.log("AAAAA"+OsType)
            this.props.LookupServers.Servers.Server.filter((item) => {
                // console.log("BBBBB"+item["@OSType"])
                if (item["@OSType"] === OsType) {
                    if (item["@ServerType"] === ServerType) {
                        // if(this.state.ServerOptions.length >0){
                        //     this.state.ServerOptions.map((server)=>{
                        //         if(server===item["ServerName"]){
                        //             serverduplicate=true;

                        //         }

                        //     })  
                        // }

                        this.state.ServerOptions.push(item["ServerName"]);


                        //if(!serverduplicate){
                        //   this.state.ServerOptions.push(item["ServerName"]);
                        //}

                        if (!defaultserver) {
                            this.state.Servervalue = this.state.ServerOptions[0];
                        }
                        //Default CPUSpeed and Cache                       
                        if (item["ServerName"] === this.state.Servervalue) {
                            let cache = parseInt(item["Cache"], 10) / 1024;
                            if (this.state.OperatingSystemvalue !== "HP-UX") {
                                this.state.CpuspeedCacheoptions.push(item["Speed"] + "/" + cache.toString() + "MB" + "/" + item["Model"])
                            }
                            else {
                                this.state.CpuspeedCacheoptions.push(item["Speed"] + "/" + cache.toString() + "MB")
                            }

                            if (!defaultCpuspeed) {
                                this.state.CpuspeedCachevalue = this.state.CpuspeedCacheoptions[0];
                            } else { }
                            //Default NoofCpu


                            if (this.state.CpuspeedCachevalue !== undefined && this.state.CpuspeedCachevalue !== null && this.state.CpuspeedCachevalue !== " " && this.state.CpuspeedCachevalue !== "") {
                                var cpu = this.state.CpuspeedCachevalue.split("/");
                                if (this.state.OperatingSystemvalue !== "HP-UX") {
                                    if (cpu !== undefined && cpu !== null && cpu !== " " && cpu.length > 1) {
                                        if (cpu[2].toString() === item["Model"]) {
                                            this.state.NoofCPUSvalueoptions = [];
                                            if (Array.isArray(item.Processors.P)) {
                                                item.Processors.P.filter((num) => {
                                                    this.state.NoofCPUSvalueoptions.push(num["@ProcModel"])
                                                })
                                            } else {
                                                this.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"])
                                            }

                                        }
                                        else { }
                                    }

                                }
                                else {
                                    // this.state.NoofCPUSvalueoptions=[];
                                    /* Changes by Vinay added cpu  !== undefined && cpu  !== null && cpu  !== " ", for CID:10089*/
                                    if (cpu !== undefined && cpu !== null && cpu !== " " && cpu[0].toString() === item["Speed"]) {
                                        this.state.NoofCPUSvalueoptions = [];
                                        if (Array.isArray(item.Processors.P)) {
                                            item.Processors.P.filter((num) => {
                                                //Changes by Vinay if condition added to remove duplicate proc models.
                                                if (this.state.NoofCPUSvalueoptions.indexOf(num["@procModel"]) !== -1)
                                                    this.state.NoofCPUSvalueoptions.push(num["@ProcModel"])
                                            })
                                        } else {
                                            this.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"])
                                        }
                                        if (cpu !== undefined && cpu !== null && cpu !== " " && cpu.length > 1) {
                                            Cac = cpu[1].split("MB")
                                            if ((parseInt(Cac, 10) * 1024).toString() === item["Cache"]) {
                                                item.Processors.P.filter((num) => {
                                                    this.state.NoofCPUSvalueoptions.push(num["@ProcModel"])
                                                })
                                            }
                                        }

                                    }
                                }
                            }

                            if (this.state.NoofCPUSvalueoptions.length === 0) {
                                this.state.NoofCPUSvalueoptions = [];
                                if (Array.isArray(item.Processors.P)) {
                                    item.Processors.P.filter((num) => {
                                        this.state.NoofCPUSvalueoptions.push(num["@ProcModel"])
                                    })
                                } else {
                                    this.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"])
                                }
                            }
                            if (!defaultNoofcpu) {
                                this.state.NoofCPUSvalue = this.state.NoofCPUSvalueoptions[0];
                            }
                            if (cpu !== undefined && cpu !== null && cpu !== " " && cpu.length > 1) {
                                Cac = cpu[1].split("MB")
                                /*Changes by Vinay for Crashing issue on selecting HP-UX*/
                                var checkCondition = false;
                                try {
                                    if ((cpu[0].toString() === item["Speed"]) && (parseInt(Cac[0] * 1024, 10).toString() === item["Cache"]) && (cpu[2].toString() === item["Model"])) {
                                        checkCondition = true
                                    }
                                } catch (e) {
                                    if (e instanceof TypeError) {
                                        console.log("TypeError")
                                    }
                                    if ((cpu[0].toString() === item["Speed"]) && (parseInt(Cac[0] * 1024, 10).toString() === item["Cache"])) {
                                        checkCondition = true
                                    }
                                }
                                //if ((cpu[0].toString() === item["Speed"]) && (parseInt(Cac[0] * 1024, 10).toString() === item["Cache"])) {
                                if (checkCondition) {
                                    if (Array.isArray(item.Processors.P)) {
                                        item.Processors.P.filter((num) => {
                                            if (this.state.NoofCPUSvalue === num["@ProcModel"]) {
                                                LookupValue = num["#text"]
                                                    LookupValue = ((Math.round(LookupValue / 0.855) / 0.721) / 0.95);
                                                    LookupValue = Math.floor(LookupValue / 10);
                                                    LookupValue = parseInt((LookupValue * 10), 10);
                                                    LookupTotalValue = LookupValue;

                                                if (this.state.SAPversionvalue === "5.0") {
                                                    LookupTotalValue = (parseInt(LookupTotalValue * 0.9, 10))
                                                }
                                                else if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                    LookupTotalValue = (parseInt(LookupTotalValue * 0.855, 10))
                                                }
                                                else if (this.state.SAPversionvalue === "4.6") {
                                                    LookupTotalValue = (parseInt(LookupTotalValue * 1.052631579, 10))
                                                }

                                                if ((this.state.OperatingSystemvalue === "Linux") && this.state.ServerTypevalue === "Integrity") {
                                                    LookupTotalValue = (parseInt(LookupTotalValue - (LookupTotalValue * 0.1), 10))
                                                }
                                                if (said === 'SAPHANA' && this.state.SAPversionvalue === "4.7") {
                                                    LookupTotalValue = LookupValue
                                                }
                                                else if (this.state.onEPH3 === true) {
                                                    DbNewSap = LookupTotalValue / 10;
                                                    LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                    LookupValue = LookupTotalValue;
                                                }
                                                else if (this.state.onEPH4 === true) {
                                                    if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                        DbNewSap = (LookupTotalValue * 0.721)
                                                        /*Changes by Vinay, same code is being executed regardsless of condition, for CID:10022 (9/10) */
                                                        /*if (this.state.OnlyNewServersRadiobutton === true) {*/
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                        /*}
                                                        else {
                                                            DbNewSap = DbNewSap / 10;
                                                            LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                            LookupValue = LookupTotalValue;
                                                        }*/

                                                    }
                                                    else {
                                                        DbNewSap = (LookupTotalValue * 0.79) / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }
                                                }
                                                else if (this.state.onEPH5 === true) {
                                                    if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                        DbNewSap = (LookupTotalValue * 0.721 * 0.95)
                                                        /*Changes by Vinay, same code is being executed regardsless of condition, for CID:10022 (10/10) */
                                                        /*if (this.state.OnlyNewServersRadiobutton === true) {*/
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                        /*}
                                                        else {
                                                            DbNewSap = DbNewSap / 10;
                                                            LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                            LookupValue = LookupTotalValue;
                                                        }*/
                                                    }
                                                    else {
                                                        DbNewSap = (LookupTotalValue * 0.79 * 0.79) / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }
                                                }
                                                if (LookupTotalValue === 0) {
                                                    LookupValue = "No entry found!"
                                                }
                                            }

                                        })
                                    } else {

                                        if (this.state.NoofCPUSvalue === item.Processors.P["@ProcModel"]) {
                                            LookupValue = item.Processors.P["#text"]
                                                LookupValue = ((Math.round(LookupValue / 0.855) / 0.721) / 0.95);
                                                LookupValue = Math.floor(LookupValue / 10);
                                                LookupValue = parseInt((LookupValue * 10), 10);
                                                LookupTotalValue = LookupValue;

                                            if (this.state.SAPversionvalue === "5.0") {
                                                LookupTotalValue = (parseInt(LookupTotalValue * 0.9, 10))
                                            }
                                            else if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                LookupTotalValue = (parseInt(LookupTotalValue * 0.855, 10))
                                            }
                                            else if (this.state.SAPversionvalue === "4.6") {
                                                LookupTotalValue = (parseInt(LookupTotalValue * 1.052631579, 10))
                                            }

                                            if ((this.state.OperatingSystemvalue === "Linux") && this.state.ServerTypevalue === "Integrity") {
                                                LookupTotalValue = (parseInt(LookupTotalValue - (LookupTotalValue * 0.1), 10))
                                            }

                                            if (said === 'SAPHANA' && this.state.SAPversionvalue === "4.7") {
                                                LookupTotalValue = LookupValue
                                            }
                                            else if (this.state.onEPH3 === true) {
                                                DbNewSap = LookupTotalValue / 10;
                                                LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                LookupValue = LookupTotalValue;
                                            }
                                            else if (this.state.onEPH4 === true) {
                                                if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                    DbNewSap = (LookupTotalValue * 0.721)
                                                    /*Changes by Vinay, same code is being executed regardsless of condition, for CID:10019 (9/10) */
                                                    /*if (this.state.OnlyNewServersRadiobutton === true) {*/
                                                    DbNewSap = DbNewSap / 10;
                                                    LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                    LookupValue = LookupTotalValue;
                                                    /*}
                                                    else {
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }*/
                                                }
                                                else {
                                                    DbNewSap = (LookupTotalValue * 0.79) / 10;
                                                    LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                    LookupValue = LookupTotalValue;
                                                }
                                            }
                                            else if (this.state.onEPH5 === true) {
                                                if (this.state.SAPversionvalue === "6.0" || this.state.SAPversionvalue === "6.0 EHP4" || this.state.SAPversionvalue === "6.0 EHP5") {
                                                    DbNewSap = (LookupTotalValue * 0.721 * 0.95)
                                                    /*Changes by Vinay, same code is being executed regardsless of condition, for CID:10019 (10/10) */
                                                    /*if (this.state.OnlyNewServersRadiobutton === true) {*/
                                                    DbNewSap = DbNewSap / 10;
                                                    LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                    LookupValue = LookupTotalValue;
                                                    /*}
                                                    else {
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }*/
                                                }
                                                else {
                                                    DbNewSap = (LookupTotalValue * 0.79 * 0.79) / 10;
                                                    LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                    LookupValue = LookupTotalValue;
                                                }
                                            }
                                            if (LookupTotalValue === 0) {
                                                LookupValue = "No entry found!"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            })
            let Severduplicates = [];
            let len = this.state.ServerOptions.length;

            for (let i = 0; i < len; i++) {
                if (Severduplicates.indexOf(this.state.ServerOptions[i]) === -1) {
                    Severduplicates.push(this.state.ServerOptions[i]);
                }
            }
            this.state.ServerOptions = Severduplicates;
            // this.state.ServerOptions=[...new Set(this.state.ServerOptions)]
            // this.state.CpuspeedCacheoptions=[...new Set(this.state.CpuspeedCacheoptions)]  
            //  this.state.NoofCPUSvalueoptions=[...new Set(this.state.NoofCPUSvalueoptions)]  

            if (this.state.ServerOptions.length === 0 || this.state.CpuspeedCacheoptions === 0 || this.state.NoofCPUSvalueoptions === 0) {
                this.state.Servervalue = "No Data";
                this.state.CpuspeedCachevalue = "No Data";
                this.state.NoofCPUSvalue = "No Data";
                LookupValue = "No entry found!"
            }
            // if(!defaultserver)
            //     this.state.Servervalue= this.state.ServerOptions[0];

            //Default CPUSpeed and Cache
            //  this.props.LookupServers.Servers.Server.filter((item)=>{
            //     console.log("BBBBB"+item["@OSType"])
            //     if(item["@OSType"]===OsType){
            //           if(item["@ServerType"]===ServerType){
            //                 if(item["ServerName"]=== this.state.Servervalue){
            //                     let cache=parseInt(item["Cache"], 10)/1024;
            //                     if(this.state.OperatingSystemvalue!=="HP-UX")
            //                         this.state.CpuspeedCacheoptions .push(item["Speed"]+"/"+cache.toString()+"MB"+"/"+ item["Model"])
            //                     else
            //                          this.state.CpuspeedCacheoptions .push(item["Speed"]+"/"+cache.toString()+"MB")
            //              }
            //           }
            //     }      
            // })

        }
        var lookup = "";
        if (this.state.LookupSAP === true) {
            lookup = <Layer className="Lookuplayer">
                <Box separator="none" size="large" pad={{ between: "small" }} style={{ border: "0px", width: '100%' }}>
                    <Box direction="row" separator="bottom" pad={{ between: "small" }} style={{ backgroundColor: '#425563' }}>
                        <Box style={{ width: "95%", margin: "10px" }} >
                            <Heading tag="h4" style={{ marginBottom: '0px', color: '#fff' }}>SAPS Lookup </Heading>
                        </Box>
                        <Box id="informationiconbox" style={{ marginTop: "10px" }} direction="row" margin="none" pad="none" justify="end" onClick={this.LookupSAPClose} >
                            <CloseIcon size='small' />
                        </Box>
                    </Box>
                    <Box margin="none" pad={{ between: 'small' }} separator="none" style={{ padding: '0px', alignItems: "center" }} >
                        <Paragraph>{LookupValue}</Paragraph>
                    </Box>
                </Box>
            </Layer>
        }
        if (this.state.CpuspeedCachevalue === "" || this.state.CpuspeedCachevalue === undefined || this.state.CpuspeedCachevalue === null) {
            this.state.CpuspeedCachevalue = this.state.CpuspeedCacheoptions[0];
        }
        if (this.state.NoofCPUSvalue === "" || this.state.NoofCPUSvalue === undefined || this.state.NoofCPUSvalue === null) {
            this.state.NoofCPUSvalue = this.state.NoofCPUSvalueoptions[0];
            // this.state.NoofCPUSvalue ="2"
        }

        return (
            <Box separator="none" size="large" pad={{ between: "small" }} style={{ border: "0px"}}>
                <Box direction="row" separator="bottom" pad={{ between: "small" }} style={{ backgroundColor: '#425563' }}>
                    <Box style={{ width: "95%", margin: "10px" }} >
                        <Heading tag="h4" style={{ marginBottom: '0px', color: '#fff' }}>Select the required fields for the SAPS value</Heading>
                    </Box>
                    {this.props.isFromExternalApp? 
                    <Button id="backToSSETyes" primary={false} plain={true} style={{position:'absolute',right:'0',color:'white'}}  /* icon={<Revert size="small" colorIndex='accent-3' />} */ label='Close' onClick={()=>{window.location.replace(this.props.externalAppProps.ssetUrl);}} className="ReverseSavewrkloadbtn" />
                    :
                    <Box id="informationiconbox" style={{ marginTop: "10px" }} direction="row" margin="none" pad="none" justify="end" onClick={() => this.props.onClose()} >
                        <CloseIcon size='small' />
                    </Box>}
                </Box>
                {lookup}
                {!this.props.LookupServers ?  
                <Box separator="none" size="large" pad={{ between: "small" }} style={{ padding:'36%', border: "0px", overflow: "hidden" }}>
                Looking for SAPs value <br/> Please wait.....
             </Box> :
                <Box margin='none' pad={{ between: 'small' }} style={{ padding: '0px' }}>
                    {/*<Box  margin='none' pad="none"   pad={{between: 'small'}} style={{ padding:'0px'}}  > 
                                                                    <Heading tag='h5' strong={true} margin='small' style={{ marginTop: '0%',marginLeft:"30px" }}>Select the required fields for the SAPS value</Heading>                         
                                                            </Box> */}
                    <Box direction="row" margin='none' pad={{ between: 'small' }} style={{ padding: '0px', marginBottom: "0px" }}>
                        <Box margin='none' pad={{ between: 'small' }} style={{ padding: '0px', width: "45%", marginLeft: "12px" }}>
                            <Box margin="none" pad={{ between: 'small' }} separator="all" style={{ padding: '0px' }} >

                                <FormField className="CustomInputFormField" label='Types of Servers'>
                                    <RadioButton label="All Servers" checked={this.state.AllServersRadiobutton} onChange={this.onAllServersRadiobuttonChange} />
                                    <RadioButton label="Only New Servers" checked={this.state.OnlyNewServersRadiobutton} onChange={this.onOnlyNewServersRadiobuttonChange} />
                                    {/*<RadioButton label="Only Old Servers" checked={this.state.OnlyOldServersRadiobutton} onChange={this.onOnlyOldServersRadiobuttonChange} />
                                    <RadioButton label="Not New Servers" checked={this.state.NotNewServersRadiobutton} onChange={this.onNotNewServersRadiobuttonChange} />*/}
                                </FormField>
                            </Box>
                            <Box margin="none" pad={{ between: 'small' }} separator="all" style={{ padding: '0px' }} >
                                <FormField className="CustomInputFormField" label='Types of Enhancement Packages'>
                                    <RadioButton label="SAP ECC 6.0 EHP3" checked={this.state.onEPH3} onChange={this.onEPH3RadiobuttonChange} />
                                    <RadioButton label="SAP ECC 6.0 EHP4" checked={this.state.onEPH4} onChange={this.onEPH4RadiobuttonChange} />
                                    <RadioButton label="SAP ECC 6.0 EHP5" checked={this.state.onEPH5} onChange={this.onEPH5RadiobuttonChange} />
                                    <Form style={{ padding: '10px', width: "255px" }}>
                                        <FormField className="CustomInputFormField" label='SAP Version'>
                                            <Select value={this.state.SAPversionvalue} options={this.state.SAPversionOptions} onChange={this.onSAPversionChange} />
                                        </FormField>
                                    </Form>
                                </FormField>

                            </Box>

                        </Box>
                        <Box margin='none' pad={{ between: 'small' }} style={{ padding: '0px', width: "45%" }}>
                            <Box margin="none" pad={{ between: 'small' }} separator="none"  >
                                <Form>
                                    <FormField className="CustomInputFormField" label='Operating System' style={{ width: "260px" }}>
                                        <Select value={this.state.OperatingSystemvalue} options={this.state.OperatingSystemOptions} onChange={this.onOperatingSystemChange} />
                                    </FormField>
                                </Form>
                            </Box>
                            <Box margin="none" pad={{ between: 'small' }} separator="none">
                                <Form>
                                    <FormField className="CustomInputFormField" label='Server Type' style={{ width: "260px" }}>
                                        <Select value={this.state.ServerTypevalue} options={this.state.ServerTypeOptions} onChange={this.onServerTypeChange} />
                                    </FormField>
                                </Form>
                            </Box>
                            <Box margin="none" pad={{ between: 'small' }} separator="none"  >
                                <Form>
                                    <FormField className="CustomInputFormField" label='Server' style={{ width: "260px" }}>
                                        <Select value={this.state.Servervalue} options={this.state.ServerOptions} onChange={this.onServerChange} />
                                    </FormField>
                                </Form>
                            </Box>
                            <Box margin="none" pad={{ between: 'small' }} separator="none" >
                                <Form>
                                    <FormField className="CustomInputFormField" label='CPU speed/Cache' style={{ width: "260px" }}>

                                        <Select value={this.state.CpuspeedCachevalue} options={this.state.CpuspeedCacheoptions} onChange={this.onCpuspeedCacheChange} />
                                    </FormField>
                                </Form>
                            </Box>
                            <Box margin="none" pad={{ between: 'small' }} separator="none"  >
                                <Form>
                                    <FormField className="CustomInputFormField" label='Nos of CPUs' style={{ width: "260px" }}>

                                        <Select value={this.state.NoofCPUSvalue} options={this.state.NoofCPUSvalueoptions} onChange={this.onNoofCPUSvalueChange} />
                                    </FormField>
                                </Form>
                            </Box>

                        </Box>
                    </Box>
                    <Box direction="row" pad={{ between: 'none' }} margin="none" style={{marginBottom:'0px'}}>
                    <Label size='medium' margin='none' style={{fontWeight:'bold',marginLeft:'10px',width:'60px'}} >Note :</Label> 
                    <Label size='small' margin='none' style={{fontWeight:'bold',marginLeft:'5px'}} >SAPS numbers on this tool are a mix of measured and calculated results, SD-2-tier with 1 sec RT @100% CPU usage.</Label>                    
                    </Box>
                    <Box direction="row" pad={{ between: 'small' }} margin="none" style={{ alignSelf: "center",marginTop:'-5px' }}>
                        <Button style={{ margin: "10px", backgroundColor: "#01a982", color: "#fff" }} label='Lookup SAPS...' onClick={this.onLookupSAPClick} />

                    </Box>
                </Box>}
            </Box>


        );
    }
}
const mapStateToProps = (state) => {
    return {
        //ProductionEnvironment:state.sizerWorkload.workload.UserInputs.Environments.ProductionEnvironment,\
        LookupServers: state.sizerWorkload.lookupservers,

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        OnFetchLookupServersList: (value) => {
            dispatch(fetchLookupServersList(value));
        }
    };

};
export default connect(mapStateToProps, mapDispatchToProps)(SANStorage);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/SAPLOOKUP.js